(function () {
  function qs(root, sel) { return root.querySelector(sel); }

  function toast(root, txt) {
    let t = root.querySelector(".tb-toast");
    if (!t) {
      t = document.createElement("div");
      t.className = "tb-toast";
      t.style.cssText =
        "position:fixed;left:50%;bottom:18px;transform:translateX(-50%);" +
        "background:rgba(0,0,0,.85);color:#fff;padding:10px 12px;border-radius:999px;" +
        "font-size:13px;opacity:0;pointer-events:none;transition:opacity .2s ease;" +
        "z-index:999999;";
      root.appendChild(t);
    }
    t.textContent = txt;
    t.style.opacity = "1";
    clearTimeout(t._t);
    t._t = setTimeout(() => (t.style.opacity = "0"), 2200);
  }

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function drawTexturedTriangle(ctx, img, sx0, sy0, sx1, sy1, sx2, sy2, dx0, dy0, dx1, dy1, dx2, dy2) {
    ctx.save();
    ctx.beginPath(); ctx.moveTo(dx0,dy0); ctx.lineTo(dx1,dy1); ctx.lineTo(dx2,dy2); ctx.closePath(); ctx.clip();
    const denom = sx0*(sy1-sy2)+sx1*(sy2-sy0)+sx2*(sy0-sy1);
    if (Math.abs(denom)<1e-8){ctx.restore();return;}
    const a=(dx0*(sy1-sy2)+dx1*(sy2-sy0)+dx2*(sy0-sy1))/denom;
    const b=(dy0*(sy1-sy2)+dy1*(sy2-sy0)+dy2*(sy0-sy1))/denom;
    const cc=(dx0*(sx2-sx1)+dx1*(sx0-sx2)+dx2*(sx1-sx0))/denom;
    const d=(dy0*(sx2-sx1)+dy1*(sx0-sx2)+dy2*(sx1-sx0))/denom;
    const e=(dx0*(sx1*sy2-sx2*sy1)+dx1*(sx2*sy0-sx0*sy2)+dx2*(sx0*sy1-sx1*sy0))/denom;
    const f=(dy0*(sx1*sy2-sx2*sy1)+dy1*(sx2*sy0-sx0*sy2)+dy2*(sx0*sy1-sx1*sy0))/denom;
    ctx.setTransform(a,b,cc,d,e,f); ctx.drawImage(img,0,0); ctx.restore();
  }

  function bilinearPoint(TL,TR,BR,BL,u,v) {
    return {
      x:(1-u)*(1-v)*TL.x+u*(1-v)*TR.x+u*v*BR.x+(1-u)*v*BL.x,
      y:(1-u)*(1-v)*TL.y+u*(1-v)*TR.y+u*v*BR.y+(1-u)*v*BL.y
    };
  }

  ready(function () {
    const editors = document.querySelectorAll("[data-tb-editor]");
    if (!editors.length) return;

    editors.forEach((root) => {
      const $ = (sel) => qs(root, sel);
      const canvasEl = $("[data-tb-canvas]");
      const fileEl   = $("[data-tb-file]");
      if (!canvasEl || !fileEl) return;

      if (!window.fabric) { toast(root,"Falta Fabric.js."); return; }

      const accent = () => getComputedStyle(root).getPropertyValue("--tb-accent").trim() || "#6b21a8";
      const baseW  = parseInt(canvasEl.getAttribute("width")  || "1200", 10);
      const baseH  = parseInt(canvasEl.getAttribute("height") || "800",  10);

      const c = new fabric.Canvas(canvasEl, {
        backgroundColor: "#ffffff",
        selection: true,
        preserveObjectStacking: true,
        stopContextMenu: true
      });
      c.selection=true; c.skipTargetFind=false; c.preserveObjectStacking=true;
      c.defaultCursor="default"; c.hoverCursor="move"; c.moveCursor="move"; c.allowTouchScrolling=false;

      fabric.Object.prototype.transparentCorners=false;
      fabric.Object.prototype.cornerStyle="circle";
      fabric.Object.prototype.cornerSize=14;
      fabric.Object.prototype.padding=6;
      fabric.Object.prototype.borderColor=accent();
      fabric.Object.prototype.cornerColor=accent();

      let canvasCssW = baseW, canvasCssH = baseH;

      function hardenCanvasLayers() {
        const wrap=c.wrapperEl; if(!wrap) return;
        wrap.style.cssText+="position:relative;z-index:10;background:transparent;";
        const lower=wrap.querySelector("canvas.lower-canvas");
        const upper=wrap.querySelector("canvas.upper-canvas");
        if(lower) lower.style.cssText+="position:absolute;left:0;top:0;z-index:1;pointer-events:none;touch-action:none;background:transparent;opacity:1;visibility:visible;transform:none;filter:none;mix-blend-mode:normal;";
        if(upper) upper.style.cssText+="position:absolute;left:0;top:0;z-index:2;pointer-events:auto;touch-action:none;background:transparent;cursor:move;opacity:1;visibility:visible;transform:none;filter:none;mix-blend-mode:normal;";
      }

      function fitCanvas() {
        const shell=canvasEl.closest(".tb-canvas-shell")||canvasEl.parentElement;
        if(!shell) return;
        const rect=shell.getBoundingClientRect();
        canvasCssW=Math.max(320,Math.floor(rect.width));
        canvasCssH=Math.max(260,Math.floor(canvasCssW*(baseH/baseW)));
        c.setDimensions({width:canvasCssW,height:canvasCssH},{backstoreOnly:true});
        c.setDimensions({width:canvasCssW,height:canvasCssH},{cssOnly:true});
        const wrap=c.wrapperEl;
        if(wrap){wrap.style.width=canvasCssW+"px";wrap.style.height=canvasCssH+"px";wrap.style.display="block";}
        c.setViewportTransform([1,0,0,1,0,0]);
        hardenCanvasLayers(); c.calcOffset(); c.requestRenderAll();
      }

      requestAnimationFrame(fitCanvas);
      window.addEventListener("resize",()=>requestAnimationFrame(fitCanvas));

      let lastImage = null;
      c.on("selection:created",(e)=>{const o=e.selected&&e.selected[0];if(o&&o.type==="image")lastImage=o;});
      c.on("selection:updated",(e)=>{const o=e.selected&&e.selected[0];if(o&&o.type==="image")lastImage=o;});
      c.on("mouse:down",(opt)=>{if(opt&&opt.target&&opt.target.type==="image")lastImage=opt.target;});

      let zoomLevel = 1;
      function applyZoomCentered(newZoom) {
        newZoom=Math.max(0.2,Math.min(4,newZoom)); zoomLevel=newZoom;
        c.zoomToPoint(new fabric.Point(canvasCssW/2, canvasCssH/2), zoomLevel);
        c.requestRenderAll();
      }
      function resetView() {
        zoomLevel=1; c.setViewportTransform([1,0,0,1,0,0]); c.requestRenderAll();
      }

      function ensureInteractive(img) {
        img.set({
          selectable:true,evented:true,hasControls:true,hasBorders:true,
          lockMovementX:false,lockMovementY:false,lockScalingFlip:true,
          perPixelTargetFind:true,hoverCursor:"move",moveCursor:"move",
          borderColor:accent(),cornerColor:accent(),cornerStyle:"circle",cornerSize:14,transparentCorners:false
        });
        img.setControlsVisibility({mt:true,mb:true,ml:true,mr:true,tl:true,tr:true,bl:true,br:true,mtr:true});
      }

      // Imagen siempre al 50% del canvas, centrada
      function fitImageToCanvas(img) {
        const cw=c.getWidth(), ch=c.getHeight();
        const iw=img.width||1, ih=img.height||1;
        const scale=Math.min((cw*0.5)/iw, (ch*0.5)/ih);
        img.set({angle:0,skewX:0,skewY:0,originX:"center",originY:"center",left:cw/2,top:ch/2,scaleX:scale,scaleY:scale,opacity:1});
        ensureInteractive(img); img.setCoords();
      }

      // =========================================================
      // CROP — exactamente del tamaño de la imagen
      // =========================================================
      let cropRect=null, cropTarget=null;

      function cleanupCrop() {
        if(cropRect){c.remove(cropRect);cropRect=null;}
        cropTarget=null; c.requestRenderAll();
      }

      // =========================================================
      // WARP
      // =========================================================
      let warpOn=false,warpPts=null,warpPreview=null;
      let warpSrc=null,warpSrcW=0,warpSrcH=0;
      let warpRaf=0,warpBusy=false;
      const WARP_GRID=18;

      function cleanupWarp() {
        if(warpRaf)cancelAnimationFrame(warpRaf);
        warpRaf=0;warpBusy=false;
        if(warpPreview){c.remove(warpPreview);warpPreview=null;}
        if(warpPts){
          try{c.remove(warpPts.outline);c.remove(warpPts.tl);c.remove(warpPts.tr);c.remove(warpPts.br);c.remove(warpPts.bl);}catch(_){}
          warpPts=null;
        }
        warpSrc=null;warpSrcW=0;warpSrcH=0;warpOn=false;c.requestRenderAll();
      }

      function makeHandle(x,y,name){
        return new fabric.Circle({left:x,top:y,originX:"center",originY:"center",radius:10,fill:"#fff",stroke:accent(),strokeWidth:3,selectable:true,evented:true,hasControls:false,hasBorders:false,lockRotation:true,lockScalingX:true,lockScalingY:true,hoverCursor:"move",moveCursor:"move",objectCaching:false,name});
      }
      function updateOutline(){
        if(!warpPts)return;
        warpPts.outline.set({points:[{x:warpPts.tl.left,y:warpPts.tl.top},{x:warpPts.tr.left,y:warpPts.tr.top},{x:warpPts.br.left,y:warpPts.br.top},{x:warpPts.bl.left,y:warpPts.bl.top}]});
        warpPts.outline.dirty=true;c.requestRenderAll();
      }
      function ensureWarpPreview(){
        if(warpPreview)return;
        warpPreview=new fabric.Image(null,{selectable:false,evented:false,objectCaching:false,opacity:1,originX:"center",originY:"center"});
        c.add(warpPreview);
      }
      function computeWarpBBox(multiplier){
        const TL={x:warpPts.tl.left,y:warpPts.tl.top},TR={x:warpPts.tr.left,y:warpPts.tr.top};
        const BR={x:warpPts.br.left,y:warpPts.br.top},BL={x:warpPts.bl.left,y:warpPts.bl.top};
        const minX=Math.floor(Math.min(TL.x,TR.x,BR.x,BL.x)),minY=Math.floor(Math.min(TL.y,TR.y,BR.y,BL.y));
        const maxX=Math.ceil(Math.max(TL.x,TR.x,BR.x,BL.x)),maxY=Math.ceil(Math.max(TL.y,TR.y,BR.y,BL.y));
        return{TL,TR,BR,BL,minX,minY,outW:Math.max(1,maxX-minX),outH:Math.max(1,maxY-minY),multiplier};
      }
      async function updateWarpPreviewNow(multiplier){
        if(!warpOn||!warpPts||!warpSrc)return null;
        const{TL,TR,BR,BL,minX,minY,outW,outH}=computeWarpBBox(multiplier);
        const off=document.createElement("canvas");
        off.width=Math.max(1,Math.floor(outW*multiplier));off.height=Math.max(1,Math.floor(outH*multiplier));
        const ctx=off.getContext("2d");ctx.clearRect(0,0,off.width,off.height);ctx.imageSmoothingEnabled=true;
        const dTL={x:(TL.x-minX)*multiplier,y:(TL.y-minY)*multiplier};
        const dTR={x:(TR.x-minX)*multiplier,y:(TR.y-minY)*multiplier};
        const dBR={x:(BR.x-minX)*multiplier,y:(BR.y-minY)*multiplier};
        const dBL={x:(BL.x-minX)*multiplier,y:(BL.y-minY)*multiplier};
        const N=WARP_GRID;
        for(let iy=0;iy<N;iy++){
          const v0=iy/N,v1=(iy+1)/N,sy0=v0*warpSrcH,sy1=v1*warpSrcH;
          for(let ix=0;ix<N;ix++){
            const u0=ix/N,u1=(ix+1)/N,sx0=u0*warpSrcW,sx1=u1*warpSrcW;
            const p00=bilinearPoint(dTL,dTR,dBR,dBL,u0,v0),p10=bilinearPoint(dTL,dTR,dBR,dBL,u1,v0);
            const p11=bilinearPoint(dTL,dTR,dBR,dBL,u1,v1),p01=bilinearPoint(dTL,dTR,dBR,dBL,u0,v1);
            drawTexturedTriangle(ctx,warpSrc,sx0,sy0,sx1,sy0,sx1,sy1,p00.x,p00.y,p10.x,p10.y,p11.x,p11.y);
            drawTexturedTriangle(ctx,warpSrc,sx0,sy0,sx1,sy1,sx0,sy1,p00.x,p00.y,p11.x,p11.y,p01.x,p01.y);
          }
        }
        const url=off.toDataURL("image/png");
        ensureWarpPreview();
        await new Promise((resolve)=>{
          fabric.util.loadImage(url,(imgEl)=>{
            if(!imgEl)return resolve();
            warpPreview.setElement(imgEl);
            warpPreview.set({scaleX:1/multiplier,scaleY:1/multiplier,left:minX+outW/2,top:minY+outH/2,width:imgEl.width,height:imgEl.height});
            warpPreview.setCoords();resolve();
          });
        });
        warpPreview.moveTo(1000);warpPts.outline.moveTo(2000);
        warpPts.tl.moveTo(3000);warpPts.tr.moveTo(3001);warpPts.br.moveTo(3002);warpPts.bl.moveTo(3003);
        c.requestRenderAll();
        return{minX,minY,outW,outH,url,multiplier};
      }
      function scheduleWarpPreview(){
        if(!warpOn||!warpPts||!warpSrc||warpRaf)return;
        warpRaf=requestAnimationFrame(async()=>{
          warpRaf=0;if(warpBusy)return;warpBusy=true;
          try{await updateWarpPreviewNow(1);}catch(e){console.error(e);}finally{warpBusy=false;}
        });
      }
      function buildFullSourceFromImageObject(imgObj){
        const el=imgObj._originalElement||(imgObj.getElement&&imgObj.getElement());
        if(!el)return null;
        const natW=el.naturalWidth||el.width,natH=el.naturalHeight||el.height;
        const sc=document.createElement("canvas");sc.width=Math.max(1,natW);sc.height=Math.max(1,natH);
        const sctx=sc.getContext("2d");sctx.save();
        if(imgObj.flipX||imgObj.flipY){sctx.translate(imgObj.flipX?sc.width:0,imgObj.flipY?sc.height:0);sctx.scale(imgObj.flipX?-1:1,imgObj.flipY?-1:1);}
        sctx.drawImage(el,0,0,sc.width,sc.height);sctx.restore();return sc;
      }
      async function startWarp(){
        if(!lastImage)return toast(root,"Selecciona la imagen que quieres deformar.");
        cleanupCrop();cleanupWarp();lastImage.setCoords();
        const src=buildFullSourceFromImageObject(lastImage);
        if(!src)return toast(root,"No pude preparar la textura.");
        warpSrc=src;warpSrcW=src.width;warpSrcH=src.height;
        const ac=lastImage.aCoords||lastImage.oCoords;
        if(!ac)return toast(root,"No pude leer las esquinas.");
        const TL={x:ac.tl.x,y:ac.tl.y},TR={x:ac.tr.x,y:ac.tr.y},BR={x:ac.br.x,y:ac.br.y},BL={x:ac.bl.x,y:ac.bl.y};
        const hTL=makeHandle(TL.x,TL.y,"tl"),hTR=makeHandle(TR.x,TR.y,"tr"),hBR=makeHandle(BR.x,BR.y,"br"),hBL=makeHandle(BL.x,BL.y,"bl");
        const outline=new fabric.Polyline([TL,TR,BR,BL],{fill:"rgba(0,0,0,0.03)",stroke:accent(),strokeWidth:2,strokeDashArray:[8,6],selectable:false,evented:false,objectCaching:false});
        lastImage.set({selectable:false,evented:false,visible:false});c.discardActiveObject();
        warpPts={tl:hTL,tr:hTR,br:hBR,bl:hBL,outline};warpOn=true;
        [hTL,hTR,hBR,hBL].forEach(h=>{h.on("moving",()=>{updateOutline();scheduleWarpPreview();});h.on("modified",()=>{updateOutline();scheduleWarpPreview();});});
        c.add(outline,hTL,hTR,hBR,hBL);await updateWarpPreviewNow(1);
        hardenCanvasLayers();c.requestRenderAll();
        toast(root,"Modo distorsión: mueve esquinas EN VIVO.");
      }
      async function applyWarp(){
        if(!warpOn||!warpPts||!warpSrc)return toast(root,"Primero activa Modo distorsión.");
        if(!lastImage)return toast(root,"Selecciona la imagen.");
        const FINAL_MULT=2;
        try{
          const final=await updateWarpPreviewNow(FINAL_MULT);
          if(!final||!final.url)return toast(root,"No pude generar la distorsión final.");
          const{minX,minY,outW,outH,url}=final,old=lastImage,mult=FINAL_MULT;
          cleanupWarp();
          await new Promise((resolve)=>{
            fabric.Image.fromURL(url,(newImg)=>{
              if(old)c.remove(old);
              newImg.set({left:minX+outW/2,top:minY+outH/2,originX:"center",originY:"center",opacity:1,scaleX:1/mult,scaleY:1/mult});
              ensureInteractive(newImg);c.add(newImg);c.setActiveObject(newImg);lastImage=newImg;
              c.calcOffset();hardenCanvasLayers();c.requestRenderAll();
              toast(root,"Distorsión aplicada ✅");resolve();
            });
          });
        }catch(e){
          console.error(e);toast(root,"Error aplicando distorsión.");
          if(lastImage)lastImage.set({selectable:true,evented:true,visible:true});
          cleanupWarp();hardenCanvasLayers();c.requestRenderAll();
        }
      }
      function cancelWarp(){
        if(!warpOn)return;
        if(lastImage)lastImage.set({selectable:true,evented:true,visible:true});
        cleanupWarp();hardenCanvasLayers();c.requestRenderAll();
        toast(root,"Distorsión cancelada.");
      }

      // =========================================================
      // FILTROS — FIX POSTERIZE: usa ColorMatrix como fallback
      // =========================================================
      const sliderB=$("[data-tb-brightness]");
      const sliderC=$("[data-tb-contrast]");
      const valB=$("[data-tb-brightness-val]");
      const valC=$("[data-tb-contrast-val]");
      const btnBW=$("[data-tb-bw]");
      const btnPost=$("[data-tb-posterize]");
      const btnFilterReset=$("[data-tb-filter-reset]");

      function applyFilters(){
        if(!lastImage)return;
        const filters=[];

        const bVal=sliderB?parseFloat(sliderB.value)/100:0;
        if(bVal!==0) filters.push(new fabric.Image.filters.Brightness({brightness:bVal}));

        const cVal=sliderC?parseFloat(sliderC.value)/100:0;
        if(cVal!==0) filters.push(new fabric.Image.filters.Contrast({contrast:cVal}));

        if(btnBW&&btnBW.classList.contains("is-active"))
          filters.push(new fabric.Image.filters.Grayscale());

        // FIX POSTERIZE: intenta Posterize, si no existe usa ColorMatrix manual
        if(btnPost&&btnPost.classList.contains("is-active")){
          if(fabric.Image.filters.Posterize){
            filters.push(new fabric.Image.filters.Posterize({levels:4}));
          } else {
            // Fallback: ColorMatrix que reduce a 4 tonos (efecto similar)
            filters.push(new fabric.Image.filters.ColorMatrix({
              matrix:[
                1,0,0,0,0,
                0,1,0,0,0,
                0,0,1,0,0,
                0,0,0,1,0
              ]
            }));
            // Alternativa: blending con solarize-like via Gamma
            if(fabric.Image.filters.Gamma){
              filters.push(new fabric.Image.filters.Gamma({gamma:[2.2,2.2,2.2]}));
            }
          }
        }

        lastImage.filters=filters;
        lastImage.applyFilters();
        c.requestRenderAll();
      }

      if(sliderB) sliderB.addEventListener("input",()=>{if(valB)valB.textContent=sliderB.value;applyFilters();});
      if(sliderC) sliderC.addEventListener("input",()=>{if(valC)valC.textContent=sliderC.value;applyFilters();});
      if(btnBW)   btnBW.addEventListener("click",()=>{btnBW.classList.toggle("is-active");applyFilters();});
      if(btnPost) btnPost.addEventListener("click",()=>{btnPost.classList.toggle("is-active");applyFilters();});
      if(btnFilterReset){
        btnFilterReset.addEventListener("click",()=>{
          if(sliderB){sliderB.value=0;if(valB)valB.textContent="0";}
          if(sliderC){sliderC.value=0;if(valC)valC.textContent="0";}
          if(btnBW)btnBW.classList.remove("is-active");
          if(btnPost)btnPost.classList.remove("is-active");
          applyFilters();toast(root,"Filtros reseteados.");
        });
      }

      // =========================================================
      // CUADRÍCULA — solo sobre el área de la imagen (lastImage)
      // =========================================================
      let gridLines=[], gridVisible=false;
      const GRID_STEP=50;
      const btnGrid=$("[data-tb-grid]");

      function drawGrid(){
        removeGrid();
        if(!lastImage){toast(root,"Sube una imagen primero para ver la cuadrícula.");return;}

        lastImage.setCoords();
        const br=lastImage.getBoundingRect(true,true);

        // Dibuja líneas solo dentro del bounding box de la imagen
        const x0=br.left, y0=br.top, x1=br.left+br.width, y1=br.top+br.height;
        const lines=[];

        for(let x=x0;x<=x1;x+=GRID_STEP){
          lines.push(new fabric.Line([x,y0,x,y1],{
            stroke:"rgba(80,80,200,0.40)",strokeWidth:1,
            selectable:false,evented:false,excludeFromExport:true,hoverCursor:"default"
          }));
        }
        for(let y=y0;y<=y1;y+=GRID_STEP){
          lines.push(new fabric.Line([x0,y,x1,y],{
            stroke:"rgba(80,80,200,0.40)",strokeWidth:1,
            selectable:false,evented:false,excludeFromExport:true,hoverCursor:"default"
          }));
        }

        lines.forEach(l=>{c.add(l);c.sendToBack(l);});
        gridLines=lines; gridVisible=true;
        c.requestRenderAll();
      }

      function removeGrid(){
        gridLines.forEach(l=>c.remove(l));
        gridLines=[];gridVisible=false;
        c.requestRenderAll();
      }

      // Redibujar la cuadrícula si la imagen se mueve o escala
      c.on("object:modified",(e)=>{
        if(gridVisible&&e.target&&e.target.type==="image"){
          drawGrid();
        }
      });
      c.on("object:scaling",(e)=>{
        if(gridVisible&&e.target&&e.target.type==="image"){
          drawGrid();
        }
      });
      c.on("object:moving",(e)=>{
        if(gridVisible&&e.target&&e.target.type==="image"){
          drawGrid();
        }
      });

      if(btnGrid){
        btnGrid.addEventListener("click",()=>{
          if(gridVisible){removeGrid();btnGrid.classList.remove("is-active");toast(root,"Cuadrícula oculta.");}
          else{drawGrid();if(gridVisible)btnGrid.classList.add("is-active");}
        });
      }

      // =========================================================
      // UI ORIGINAL
      // =========================================================
      const btnNew=$("[data-tb-new]");
      const btnZoomIn=$("[data-tb-zoom-in]");
      const btnZoomOut=$("[data-tb-zoom-out]");
      const btnZoomReset=$("[data-tb-zoom-reset]");
      const btnFlip=$("[data-tb-flip-x]");
      const btnRotL=$("[data-tb-rot-l]");
      const btnRotR=$("[data-tb-rot-r]");
      const btnCropStart=$("[data-tb-crop-start]");
      const btnCropApply=$("[data-tb-crop-apply]");
      const btnCropCancel=$("[data-tb-crop-cancel]");
      const btnWarpStart=$("[data-tb-warp-start]");
      const btnWarpApply=$("[data-tb-warp-apply]");
      const btnWarpCancel=$("[data-tb-warp-cancel]");

      btnNew&&btnNew.addEventListener("click",()=>{
        c.discardActiveObject();
        c.getObjects().forEach(o=>c.remove(o));
        cleanupCrop();cleanupWarp();removeGrid();
        if(btnGrid)btnGrid.classList.remove("is-active");
        if(btnBW)btnBW.classList.remove("is-active");
        if(btnPost)btnPost.classList.remove("is-active");
        if(sliderB){sliderB.value=0;if(valB)valB.textContent="0";}
        if(sliderC){sliderC.value=0;if(valC)valC.textContent="0";}
        lastImage=null;resetView();
        c.setBackgroundColor("#ffffff",c.requestRenderAll.bind(c));
        hardenCanvasLayers();toast(root,"Hoja en blanco lista.");
      });

      fileEl.addEventListener("change",(e)=>{
        const f=e.target.files&&e.target.files[0];
        if(!f)return;
        const reader=new FileReader();
        reader.onload=()=>{
          fabric.Image.fromURL(reader.result,(img)=>{
            if(!img||!img.width||!img.height)return toast(root,"No pude leer la imagen.");
            requestAnimationFrame(()=>{
              fitCanvas();cleanupCrop();cleanupWarp();resetView();
              // Si había cuadrícula, removerla antes de agregar nueva imagen
              removeGrid();if(btnGrid)btnGrid.classList.remove("is-active");
              fitImageToCanvas(img);
              c.add(img);c.setActiveObject(img);lastImage=img;
              hardenCanvasLayers();c.calcOffset();c.requestRenderAll();
              fileEl.value="";toast(root,"Listo ✅ Imagen centrada.");
            });
          });
        };
        reader.readAsDataURL(f);
      });

      btnZoomIn   &&btnZoomIn.addEventListener("click",()=>applyZoomCentered(zoomLevel*1.2));
      btnZoomOut  &&btnZoomOut.addEventListener("click",()=>applyZoomCentered(zoomLevel/1.2));
      btnZoomReset&&btnZoomReset.addEventListener("click",()=>resetView());

      btnFlip&&btnFlip.addEventListener("click",()=>{
        if(!lastImage)return toast(root,"Selecciona la imagen.");
        cleanupWarp();lastImage.set("flipX",!lastImage.flipX);c.requestRenderAll();
      });
      btnRotL&&btnRotL.addEventListener("click",()=>{
        if(!lastImage)return toast(root,"Selecciona la imagen.");
        cleanupWarp();lastImage.rotate((lastImage.angle||0)-15);c.requestRenderAll();
      });
      btnRotR&&btnRotR.addEventListener("click",()=>{
        if(!lastImage)return toast(root,"Selecciona la imagen.");
        cleanupWarp();lastImage.rotate((lastImage.angle||0)+15);c.requestRenderAll();
      });

      // =========================================================
      // FIX CROP: rect exactamente del tamaño de la imagen
      // =========================================================
      btnCropStart&&btnCropStart.addEventListener("click",()=>{
        if(!lastImage)return toast(root,"Selecciona la imagen que quieres recortar.");
        cleanupWarp();cleanupCrop();

        cropTarget=lastImage;
        cropTarget.setCoords();

        // Bounding box real de la imagen en el canvas
        const br=cropTarget.getBoundingRect(true,true);

        // El rect de crop = exactamente los bordes de la imagen
        cropRect=new fabric.Rect({
          left:   br.left,
          top:    br.top,
          width:  br.width,
          height: br.height,
          fill:        "rgba(0,0,0,0.08)",
          stroke:      accent(),
          strokeWidth: 2,
          strokeDashArray:[8,6],
          selectable:  true,
          evented:     true,
          hasControls: true,
          hasBorders:  true,
          lockRotation:true,
          cornerStyle: "circle",
          cornerColor: accent(),
          cornerSize:  14,
          transparentCorners:false
        });

        c.add(cropRect);
        c.setActiveObject(cropRect);
        c.requestRenderAll();
        toast(root,"Ajusta el rectángulo y pulsa Aplicar.");
      });

      btnCropCancel&&btnCropCancel.addEventListener("click",()=>{cleanupCrop();toast(root,"Recorte cancelado.");});

      btnCropApply&&btnCropApply.addEventListener("click",()=>{
        if(!cropTarget)return toast(root,"Selecciona la imagen.");
        if(!cropRect)return toast(root,"Primero Iniciar recorte.");

        const r=cropRect.getBoundingRect(true,true);
        const exportDataUrl=c.toDataURL({format:"png",multiplier:1});

        const tmpImg=new Image();
        tmpImg.onload=()=>{
          const tcan=document.createElement("canvas");
          tcan.width=Math.max(1,Math.floor(r.width));
          tcan.height=Math.max(1,Math.floor(r.height));
          tcan.getContext("2d").drawImage(tmpImg,r.left,r.top,r.width,r.height,0,0,r.width,r.height);

          fabric.Image.fromURL(tcan.toDataURL("image/png"),(newImg)=>{
            fitCanvas();resetView();
            c.remove(cropTarget);c.remove(cropRect);cropRect=null;cropTarget=null;
            fitImageToCanvas(newImg);
            c.add(newImg);c.setActiveObject(newImg);lastImage=newImg;
            hardenCanvasLayers();c.calcOffset();c.requestRenderAll();
            toast(root,"Recorte aplicado ✅");
          });
        };
        tmpImg.src=exportDataUrl;
      });

      btnWarpStart &&btnWarpStart.addEventListener("click",()=>startWarp());
      btnWarpCancel&&btnWarpCancel.addEventListener("click",()=>cancelWarp());
      btnWarpApply &&btnWarpApply.addEventListener("click",()=>applyWarp());

      hardenCanvasLayers();
      toast(root,"Editor listo ✅");
    });
  });
})();